import { CategoryInterface, CategoryTooltipData } from '@core/models';

export function getCategoriesTooltip(element: {
  categories?: CategoryInterface[];
  previous_data?: { categories?: CategoryInterface[] };
}): CategoryTooltipData {
  return {
    current: element?.categories || null,
    previous: element.previous_data?.categories || null,
  };
}
